import {
  SET_BUS_LED_DATA,
  SET_TOTAL_BUS_LED,
  REMOVE_BUS_LED,
  SET_ALL_LINES_DIRECTIONS,
  SET_ALL_LINES,
  SET_BUS_LED_ALL_DATA,
  SET_BUS_LED_PAGE,
  SET_BUS_LED_PAGE_SIZE
} from "../types";

const initialState = {
  busLeds: [],
  allBusLeds: [],
  totalBusLed: 0,
  currentPage: 1,
  pageSize: 10
};

const busLedReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BUS_LED_DATA:
      return {
        ...state,
        busLeds: action.payload,
      };

    case SET_BUS_LED_ALL_DATA:
      return {
        ...state,
        allBusLeds: action.payload,
      };

    case SET_ALL_LINES_DIRECTIONS:
      return {
        ...state,
        allLinesDirections: action.payload,
      };

    case SET_ALL_LINES:
      return {
        ...state,
        allLines: action.payload,
      };

    case SET_TOTAL_BUS_LED:
      return {
        ...state,
        totalBusLed: action.payload,
      };

    case SET_BUS_LED_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };

    case SET_BUS_LED_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload
      };

    case REMOVE_BUS_LED:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default busLedReducer;
